<div>
  <!-- Botón de cerrar en la esquina superior izquierda -->
  <button rel="tooltip" type="button" class="btn btn-action float-right close-button mb-2 " (click)="closePopUp()">
    <i class="material-icons">close</i>
  </button>
  <p *ngIf="dateFilterReq">{{ getDateFilterAlert() }}</p>


  <dx-scheduler #scheduler [dataSource]="appointments" [views]="['day', 'week', 'month']" currentView="month"
    [(currentView)]="currentView" [currentDate]="currentDate" [startDayHour]="0" [endDayHour]="24"
    [editing]="{ allowAdding: false, allowDeleting: false, allowUpdating: false, allowResizing: false, allowDragging: false }"
    [showCurrentTimeIndicator]="true" [indicatorUpdateInterval]="300000" [shadeUntilCurrentTime]="true"
    [maxAppointmentsPerCell]="2" appointmentTemplate="appointment-template"
    (onAppointmentClick)="onAppointmentClick($event)" (onAppointmentDblClick)="onAppointmentDblClick($event)"
    (onAppointmentFormOpening)="onAppointmentFormOpening($event)" (onContentReady)="onSchedulerReady($event)"
    (onOptionChanged)="onOptionChanged($event)">


    <dxi-resource fieldExpr="roomId" label="Tipo" [dataSource]="resourcesData">
    </dxi-resource>

    <div *dxTemplate="let model of 'appointment-template'" [ngClass]="{
       'range-request': model.appointmentData.lessThanOneDay && currentView != 'month',
       'disabled-appointment': !canEditRequest(model.appointmentData)
     }">
      <p [ngClass]="{'no-image': !model.appointmentData.profileImage}"><fa-icon [icon]="model.appointmentData.icon"
          size="1x" class='mr-1'></fa-icon> <img *ngIf="model.appointmentData.profileImage" class="user-icon"
          [src]="'data:image/png;base64,' + model.appointmentData.profileImage"> {{model.appointmentData.text}} -
        {{model.appointmentData.type}}
        <br>
        <span
          *ngIf="model.appointmentData.lessThanOneDay && currentView != 'month'">{{model.appointmentData.timeRange}}</span>
      </p>
    </div>



  </dx-scheduler>

  <!-- Spinner -->
  <dx-load-panel [(visible)]="loading" [message]="'Cargando calendario...'" [position]="{ of: '#scheduler' }"
    [showPane]="true" [showIndicator]="true">
  </dx-load-panel>

</div>


<!-- Popup de filtros -->
<dx-popup [(visible)]="popupVisible" [width]="'80%'" [height]="'auto'" title="Filtros" [dragEnabled]="true"
  [showCloseButton]="true">

  <dx-form [formData]="filtros" [colCount]="2">

    <!-- Filtro por Tipo (Multiselect) -->
    <dxi-item dataField="tipo" editorType="dxTagBox" [editorOptions]="{ 
        items: tipos, 
        value: filtros.tipo, 
        placeholder: 'Selecciona uno o más tipos',
        showSelectionControls: true,
        applyValueMode: 'useButtons',
        searchEnabled: true
      }">
    </dxi-item>

    <!-- Filtro por Estado (multiselect) -->
    <dxi-item dataField="estado" editorType="dxTagBox" [editorOptions]="{ 
      items: estados, 
      value: filtros.estado, 
      placeholder: 'Selecciona uno o más estados',
      showSelectionControls: true,
      applyValueMode: 'useButtons',
      searchEnabled: true
    }">
    </dxi-item>

    <!-- Filtro por Empresa (multiselect) -->
    <dxi-item dataField="empresa" editorType="dxTagBox" [editorOptions]="{ 
      items: empresas, 
      value: filtros.empresa, 
      placeholder: 'Selecciona una o más empresas',
      showSelectionControls: true,
      applyValueMode: 'useButtons',
      searchEnabled: true,
      onValueChanged: actualizarEmpleados
    }">
    </dxi-item>

    <!-- Filtro por Centro (multiselect) -->
    <dxi-item dataField="centro" editorType="dxTagBox" [editorOptions]="{ 
      items: centros, 
      value: filtros.centro, 
      placeholder: 'Selecciona uno o más centros',
      showSelectionControls: true,
      applyValueMode: 'useButtons',
      searchEnabled: true
    }">
    </dxi-item>

    <!-- Filtro por Empleado (multiselect) -->
    <dxi-item dataField="empleado" editorType="dxTagBox" [editorOptions]="{ 
      items: empleados, 
      value: filtros.empleado, 
      placeholder: 'Selecciona uno o más empleados',
      showSelectionControls: true,
      applyValueMode: 'useButtons',
      searchEnabled: true
    }">
    </dxi-item>

    <!-- Botones de Aplicar y Limpiar -->
    <dxi-item class="d-flex justify-content-around mt-2 w-50 mx-auto">
      <dx-button text="Aplicar" type="default" stylingMode="contained" (onClick)="aplicarFiltros()"></dx-button>
      <dx-button text="Limpiar" type="default" stylingMode="outlined" (onClick)="limpiarFiltros()"></dx-button>
    </dxi-item>

  </dx-form>

</dx-popup>